import pagination from '../../utils/pagination'
import {
  SUPPLIES_BATCH_DELETE_REQUEST, SUPPLIES_BATCH_DELETE_SUCCESS, SUPPLIES_BATCH_DELETE_FAILURE,
  SUPPLIES_FETCH_MANY_REQUEST, SUPPLIES_FETCH_MANY_SUCCESS, SUPPLIES_FETCH_MANY_FAILURE,
  SUPPLIES_FETCH_REQUEST, SUPPLIES_FETCH_SUCCESS, SUPPLIES_FETCH_FAILURE,
  SUPPLIES_SAVE_REQUEST, SUPPLIES_SAVE_SUCCESS, SUPPLIES_SAVE_FAILURE,

  EMPTY_SUPPLIES,
  CLEAR_ERRORS
} from './types'

export default {
  [SUPPLIES_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [SUPPLIES_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [SUPPLIES_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [SUPPLIES_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [SUPPLIES_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [SUPPLIES_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [SUPPLIES_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [SUPPLIES_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [SUPPLIES_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [SUPPLIES_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [SUPPLIES_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [SUPPLIES_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_SUPPLIES] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  },
}
